const CLOUDINARY_DOMAIN = "res.cloudinary.com";

export const CLOUDINARY_ATTACHMENT_HEIGHT = "cloudinary_h";
export const CLOUDINARY_ATTACHMENT_WIDTH = "cloudinary_w";

export const isCloudinaryUrl = (url: string) => !!url?.includes(CLOUDINARY_DOMAIN);
export const replaceCloudinaryDimensions = ({ url, height, width }) => {
  if (!url) return url;

  return url
    .replace(CLOUDINARY_ATTACHMENT_HEIGHT, height || "ih") // if height is not provided, set it to ih (initial height/ original height)
    .replace(CLOUDINARY_ATTACHMENT_WIDTH, width || (height ? "auto" : "iw")); // if width is not provided, check if height is provided, if not, set it to iw (initial width/ original width), if yes set it to automatically calculate the width based on the viewport width
  // see more at https://cloudinary.com/documentation/resizing_and_cropping#setting_the_resize_dimensions
};
